// Copyright 2025, University of Maryland, All Rights Reserved
import { createApiClient, buildUrl, type RequestOptions } from '@umd-dit-ai-workspace/api-client';
import {
  getImpersonationTarget,
  IMPERSONATION_HEADER,
} from '@/subsystems/workspaces/services/impersonation-session';

const API_URL = import.meta.env.VITE_API_URL;

// Create the shared API client instance with CAS authentication
export const apiClient = createApiClient({
  baseURL: API_URL,
  debug: import.meta.env.NODE_ENV === 'development'
});

apiClient.getAxiosInstance().interceptors.request.use((config) => {
  const impersonationTarget = getImpersonationTarget();
  if (impersonationTarget) {
    config.headers[IMPERSONATION_HEADER] = impersonationTarget;
  }
  return config;
});

// Re-export the URL builder and types for compatibility
export { buildUrl, type RequestOptions };
